export function mergeClassNames(...parts: (string | undefined | false)[]) {
  return parts.filter(Boolean).join(' ');
}
